import React from "react";

/**
 * Whether something on the page has taken it over — a table or a chart
 * expanded to fill the screen. The page layout reads it to fold its header
 * away, since the header is fixed above anything an overlay can paint.
 *
 * Kept apart from the layout that provides it so that a component can say it
 * has taken the page over without importing the page: several of the ones that
 * do are in the design system, and pulling the layout in from there closes an
 * import cycle through every chart the layout's own pages render.
 */
export const FullScreenModeContext = React.createContext<{
  isFullScreenMode?: boolean;
  setIsFullScreenMode?: React.Dispatch<React.SetStateAction<boolean>>;
}>({});
